module.exports = __webpack_public_path__ + "static/DSC_9520-ee00e6b28041475bed40a354b7108b37.jpg";